import React from "react";
import styles from "./styles.module.scss";
import { ZoomIn } from "../../Animations/Zoom";
import { useNavigate } from "react-router-dom";

function FormationCard({ format }) {
  const { title, description, _id } = format;
  const navig = useNavigate();

  const SelectFormation = () => {
    navig(`/formations/formations-certifiantes/${_id}`);
  };

  return (
    <ZoomIn className={styles["main"]} offset={-500}>
      <h2>{title}</h2>
      <p>{description}</p>
      <button onClick={SelectFormation}>Décourvir</button>
    </ZoomIn>
  );
}

export default FormationCard;
